function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m309-583 140-230q5-9 13.36-13.5 8.35-4.5 17.64-4.5 9.29 0 17.64 4.5Q506-822 511-813l140 230q5 9.02 5 18.95T651-546q-5 8-12.5 13t-18.75 5h-279.5q-11.25 0-18.75-5T309-546.1q-5-8.1-5-18t5-18.9ZM696-96q-70 0-119-49t-49-119q0-70 49-119t119-49q70 0 119 49t49 119q0 70-49 119T696-96Zm-552-59.96v-215.76q0-15.28 10.34-25.78 10.34-10.5 25.62-10.5h215.76q15.28 0 25.78 10.34 10.5 10.34 10.5 25.62v215.76q0 15.28-10.34 25.78-10.34 10.5-25.62 10.5H180.28q-15.28 0-25.78-10.34-10.5-10.34-10.5-25.62Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "#5f6368"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Types.ceca6215.svg";
export { SvgComponent as ReactComponent };